import { menuContext } from './chunk-HSL7QSWM.js';
import { FocusVisibleController } from './chunk-LOFOQRT3.js';
import { useContext } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';

var MenuItems = class extends Component {
  constructor(instance) {
    super(instance);
    this.z = useContext(menuContext);
    new FocusVisibleController(instance);
  }
  onAttach(el) {
    this.z.Oc(el);
  }
};
MenuItems.el = defineElement({
  tagName: "media-menu-items"
});

export { MenuItems };
